import { useEffect } from "react";
import { buildWhatsAppUrl, companyInfo } from "../../content/siteContent";

const ensureMeta = (selector, attributes) => {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement("meta");
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    element.setAttribute(key, value);
  });
};

const ensureLink = (selector, attributes) => {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement("link");
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    element.setAttribute(key, value);
  });
};

const baseBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: companyInfo.name,
  image: companyInfo.logoUrl,
  url: typeof window !== "undefined" ? window.location.origin : "",
  telephone: companyInfo.phoneDisplay,
  email: companyInfo.email,
  address: {
    "@type": "PostalAddress",
    addressLocality: companyInfo.city,
    addressRegion: companyInfo.region,
    addressCountry: companyInfo.country,
  },
  areaServed: companyInfo.serviceArea,
  sameAs: [buildWhatsAppUrl()],
};

const SEO = ({ title, description, canonicalPath = "/", keywords = [], structuredData = [] }) => {
  useEffect(() => {
    const origin = window.location.origin;
    const canonical = `${origin}${canonicalPath}`;

    document.title = title;
    document.documentElement.lang = "pt-BR";

    ensureMeta('meta[name="description"]', {
      name: "description",
      content: description,
    });
    ensureMeta('meta[name="keywords"]', {
      name: "keywords",
      content: keywords.join(", "),
    });
    ensureMeta('meta[property="og:title"]', {
      property: "og:title",
      content: title,
    });
    ensureMeta('meta[property="og:description"]', {
      property: "og:description",
      content: description,
    });
    ensureMeta('meta[property="og:type"]', {
      property: "og:type",
      content: "website",
    });
    ensureMeta('meta[property="og:url"]', {
      property: "og:url",
      content: canonical,
    });
    ensureMeta('meta[name="theme-color"]', {
      name: "theme-color",
      content: "#0B1F3A",
    });
    ensureLink('link[rel="canonical"]', {
      rel: "canonical",
      href: canonical,
    });

    document
      .querySelectorAll('script[data-seo-jsonld="true"]')
      .forEach((node) => node.remove());

    [baseBusinessSchema, ...structuredData].forEach((schema) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.dataset.seoJsonld = "true";
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
    });
  }, [canonicalPath, description, keywords, structuredData, title]);

  return null;
};

export default SEO;